import TopCounter from "./topCounter";
import TopSlider from "./topSlider";
import SocialReviewBadges from "./socialReviewBadges";
import Specs from "./Specs";
import CompetitionTitle from "./competitionTitle";
import SubscribersOnly from "./subscribersOnly";
import UpcomingSubscribers from "./upcomingSubscribers";
import PrizesGrid from "./prizesGrid";
import CheckmarkIcon from "../../../../shared-components/icons/CheckmarkIcon";
import OtherCompButton from "./otherCompButton";
import CtaButton from "./ctaButton";
import React from "react";
import { useSubscriptionCompetitionsPrizesPageContext } from "../context";
import MoreTickets from "@/app/(custom-header)/prizes/[prizeName]/components/moreTickets";

const MobileLayout = () => {
  const { isAlreadySubscribed, activeCompetition, openTabContent, lobbyContent } =
    useSubscriptionCompetitionsPrizesPageContext();
  const youveEnteredEntry = lobbyContent.youveEntered.find(
    item => Number(item.compid) === activeCompetition.CompetitionId
  );
  return (
    <section className={"w-full"}>
      {activeCompetition.EndDateTime ? <TopCounter endDateTime={activeCompetition.EndDateTime} /> : null}

      <TopSlider />

      <div className={"bg-black"}>
        <SocialReviewBadges />
      </div>

      <div className={"flex justify-center px-2.5 py-3"}>
        <Specs />
      </div>

      <div className={`px-2.5 py-4 bg-[#F5F5F5] ${isAlreadySubscribed ? " mb-[96px]" : " mb-16"}`}>
        <div className="w-full">
          <CompetitionTitle title={activeCompetition.CtaText} onClick={e => openTabContent(e, 1)} />
        </div>

        <div className={"mt-11 flex flex-col gap-2"}>
          <SubscribersOnly isAlreadySubscribed={isAlreadySubscribed} />
          {isAlreadySubscribed ? null : <MoreTickets />}
        </div>

        <div className={"mt-6"}>
          <UpcomingSubscribers />
        </div>

        <div className={"mt-6"}>
          <PrizesGrid />
        </div>
      </div>

      <div
        className={`fixed !top-auto !bottom-0 z-[10] inset-x-0 flex items-center bg-white justify-center border-t-[#E0E0E0] px-4 py-2 border-t border-solid ${isAlreadySubscribed ? "min-h-[96px]" : "min-h-16"}`}>
        <div className={"w-full flex flex-col gap-2 items-center justify-center"}>
          {isAlreadySubscribed && youveEnteredEntry && (
            <div className={"flex items-center gap-px lg:gap-1"}>
              <CheckmarkIcon variation={4} className={"size-6 shrink-0 text-[#308835]"} />
              <div className={"text-[#308835] text-center text-xs leading-4"}>
                You entered in this competition with{" "}
                <span className={"font-semibold"}>
                  {youveEnteredEntry.nrOfTickets} {youveEnteredEntry.nrOfTickets === 1 ? "ticket" : "tickets"}
                </span>
              </div>
            </div>
          )}
          {isAlreadySubscribed ? <OtherCompButton /> : <CtaButton />}
        </div>
      </div>
    </section>
  );
};

export default MobileLayout;
